import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { Dynamic } from '@shared/registry/dynamic';

import type { ChipConfig } from '../chip/chip.types';
import type { DynamicTextConfig } from '../dynamic-text/dynamic-text.types';

import type { InfoStatsCardConfig, InfoStatsCardItem } from './info-stats-card.types';

interface ItemConfig {
  chipConfig: ChipConfig;
  valueTextConfig: DynamicTextConfig;
  icon?: string;
}

@Component({
  selector: 'app-info-stats-card',
  templateUrl: './info-stats-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Dynamic],
})
export class InfoStatsCard {
  readonly config = input.required<InfoStatsCardConfig>();

  protected readonly showIcon = computed(() => this.config().showIcon !== false);

  protected readonly titleTextConfig = computed<DynamicTextConfig>(() => ({
    text: this.config().title,
    size: 'xl',
    fontWeight: 'semibold',
    color: 'var(--infostatscard-content-color)',
  }));

  protected readonly itemConfigs = computed<ItemConfig[]>(() =>
    this.config().items.map((item: InfoStatsCardItem) => ({
      chipConfig: {
        text: item.label,
        variant: item.labelVariant ?? 'primary',
      },
      valueTextConfig: {
        text: item.value,
        size: 'xl',
        fontWeight: 'semibold',
        color: 'var(--infostatscard-content-color)',
      },
      icon: item.icon,
    })),
  );
}
